import { Button, styled } from '@mui/material';

export const CreateButton = styled(Button)(() => ({
  minWidth: 'auto',
}));
